import { render, staticRenderFns } from "./XKZ.vue?vue&type=template&id=1ec8c8ec&scoped=true&"
import script from "./XKZ.vue?vue&type=script&lang=js&"
export * from "./XKZ.vue?vue&type=script&lang=js&"
import style0 from "./XKZ.vue?vue&type=style&index=0&id=1ec8c8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec8c8ec",
  null
  
)

export default component.exports